<div [formGroup]="group">
  <label class="description">{{field.labelName}} @if (isRequired) {
    <span>*</span>
  }</label>
  @if (field.description) {
    <p [innerHTML]="field.description"></p>
  }
  <div [formArrayName]="field.labelCode" >
    @for (check of sortedOptions; track check; let i = $index) {
      <div class="check-box-cover">
        <mat-checkbox [formControlName]="i"
        (change)="check.isSelected = $event.checked;
        setCheckBoxValue($event,check, i)">
          {{check.value}}
        </mat-checkbox>
      </div>
    }
    @if (group.get(field.labelCode).invalid ) {
      <mat-error class="check-boxError">Value is mandatory</mat-error>
    }

  </div>
</div>


